import React, { useEffect, useMemo, useState } from 'react';
import styles from '../styles/aboutcomponent.module.css';
import GalleryCard from '../../common/GalleryCard';

const BoardOfDirectors = () => {
  const [board, setBoard] = useState([]);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    fetch(`${baseUrl}/documents?type=about&subType=board`)
      .then((res) => res.json())
      .then((data) => setBoard(data || []))
      .catch((err) => console.error('Error fetching board:', err));
  }, []);

  const memoizedBoard = useMemo(() => board, [board]);

  return (
    <div className={styles.about_component}>
      <h4>BOARD OF DIRECTOR-SNEHWAN</h4>
      <div className={styles.committe}>
        {memoizedBoard.map((item, index) => (
          <div key={index} className={styles.counting_item}>
            <GalleryCard photo={item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardOfDirectors;